export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_NOTIFICATIONS_FULFILLED = 'FETCH_NOTIFICATIONS_FULFILLED';
export const FETCH_NOTIFICATIONS_FAILED = 'FETCH_NOTIFICATIONS_FAILED';
export const FETCH_RECENTLY_VIEWED_DATE_FULFILLED = 'FETCH_RECENTLY_VIEWED_DATE_FULFILLED';
export const FETCH_RECENTLY_VIEWED_DATE_FAILED = 'FETCH_RECENTLY_VIEWED_DATE_FAILED';
export const SET_RECENTLY_VIEWED_DATE_FULFILLED = 'SET_RECENTLY_VIEWED_DATE_FULFILLED';
export const SET_RECENTLY_VIEWED_DATE_FAILED = 'SET_RECENTLY_VIEWED_DATE_FAILED';
export const FETCH_NEW_NOTIFICATIONS_FULFILLED = 'FETCH_NEW_NOTIFICATIONS_FULFILLED';
export const FETCH_NEW_NOTIFICATIONS_FAILED = 'FETCH_NEW_NOTIFICATIONS_FUAILED';
